import {css, unsafeCSS} from 'lit';
import {mobileBreakPoint} from '../../../styles/sizes';

// language=CSS
export const styles =
    css`
        :host {
            display: grid;
            grid-row-gap: calc(var(--sp-default-padding) / 2);
            width: 100%;
            font-size: var(--sp-font-size-larger);
            height: max-content;
        }
        .row-container {
            height: 4rem;
            width: 100%;
            display: grid;
            grid-auto-flow: column;
            grid-template-columns: 4rem auto 3.25rem;
            grid-column-gap: 1rem;
            place-items: center start;
        }

        .image {
            height: 100%;
            aspect-ratio: 1;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            border-radius: var(--sp-default-border-radius);
        }

        /* This is a legacy browser fallback */
        @supports not (aspect-ratio: 1) {
            .image {
                width: 100%;
            }
            sp-button {
                width: 100%;
            }
        }
        
        .indicator {
            display: flex;
            position: relative;
            flex-direction: column;
            width: 100%;
        }
        
        .text {
            position: absolute;
            display: grid;
            width: 100%;
            height: 100%;
            place-content: center;
            color: white;
            font-size: var(--sp-font-size-default);
        }

        .clear {
            position: absolute;
            height: 100%;
            width: 2rem;
            right: 0;
        }
        
        .clear sp-button {
            height: 100%;
            width: 2rem;
        }
        
        sl-progress-bar {
            width: 100%;
            --height: 2rem;
            --track-color: rgb(var(--sp-greymedium));
            --indicator-color: rgb(var(--sp-color-b));
        }
        
        sl-progress-bar::part(base) {
            border-radius: var(--sp-default-border-radius);
        }

        sl-progress-bar::part(label) {
            font-size: var(--sp-font-size-default);
            font-family: var(--sp-default-font-family);
        }
        
        .erroneous {
            --indicator-color: rgb(var(--sp-color-error));
            --track-color: rgb(var(--sp-color-error));
        }
        
        .inactive {
            --indicator-color: rgb(var(--sp-color-d));
        }

        @media (max-width: ${unsafeCSS(mobileBreakPoint)}) {

        }
    `;
